export const getCookie = cookieName => {
  const cookie = {};
  document.cookie.split(';').forEach(el => {
    const split = el.split('=');
    const key = split[0];
    const value = split.slice(1).join('=');
    cookie[key.trim()] = decodeURIComponent(value);
  });
  return cookie[cookieName];
};

export const setCookie = (cookieName, value) => {
  document.cookie = `${cookieName}=${value}; Secure; Path=/`;
};

export const deleteCookie = cookieName => {
  document.cookie = `${cookieName}=; Max-Age=0; Secure; Path=/`;
  document.cookie = `${cookieName}=; Expires=Thu, 01 Jan 1970 00:00:00 GMT; Secure; Path=/`;
};
